import svg4everybody from 'svg4everybody';
import Swiper from 'swiper';
import './plugins/jquery.dotdotdot';
import './plugins/jquery.fancybox';

$(function () {
  svg4everybody();

  if ($.fn.dotdotdot) {
    $(".ellipsis").dotdotdot();
  }

  if ($.fn.fancybox) {
    $("[data-fancybox]").fancybox({
      closeBtn: true,
      slideShow: false,
      fullScreen: false,
      thumbs: false,
      youtube: {
        controls: 1,
        showinfo: 0
      },
    });
  }

  if (Swiper) {

    let swiperButtons = containerSelector => ({
      navigation: {
        prevEl: `${containerSelector} .carousel__button--prev`,
        nextEl: `${containerSelector} .carousel__button--next`,
      }
    });
    let swiperButtonsUnderscore = containerSelector => ({
      navigation: {
        prevEl: `${containerSelector} .carousel__button_prev`,
        nextEl: `${containerSelector} .carousel__button_next`,
      }
    });

    $(".carousel_video").each(function (index, element) {
      let item = $(element);

      item.addClass("carousel_video_" + index);
      item.find(".carousel__button_prev").addClass("carousel__button_prev_" + index);
      item.find(".carousel__button_next").addClass("carousel__button_next_" + index);

      new Swiper(".carousel_video_" + index + ' .carousel__container', {
        slidesPerView: 'auto',
        spaceBetween: 15,
        navigation: {
          prevEl: `.carousel_video .carousel__button_prev_${index}`,
          nextEl: `.carousel_video .carousel__button_next_${index}`,
        }
      });
    });

    new Swiper('.carousel_teleprogram .carousel__container', {
      slidesPerView: 'auto',
      ...swiperButtonsUnderscore('.carousel_teleprogram')
    });

    new Swiper('.carousel_show .carousel__container', {
      slidesPerView: 'auto',
      spaceBetween: 10,
      ...swiperButtonsUnderscore('.carousel_show')
    });

    new Swiper ('.carousel--promo .carousel__container', {
      slidesPerView: 'auto',
      ...swiperButtons('.carousel--promo'),
      autoplay: 5000,
      loop:true,
    });

  }


  $(document).on('click', '.js-burger', function() {
    $(this).toggleClass('burger_active');
    $('.header__menu_mobile').toggleClass('header__menu_active');
  });

  $(document).on('click', '.menu_mobile .menu__link', function() {
    $('.js-burger').removeClass('burger_active')
    $('.header__menu_mobile').removeClass('header__menu_active');
  });

  $(document).on('click', '.js-accordion-link', function (e) {
    e.preventDefault();

    var itemActive = $(this).parents('.js-accordion').hasClass('item_active');

    $(this).parents('.js-accordion').removeClass('item_active');
    $(this).parents('.js-accordions').find('.js-accordion').removeClass('item_active');

    if (!itemActive) {
      $(this).parents('.js-accordion').addClass('item_active');
    }
  });

  var block = findGetParameter("block");
  if (block !== null) {
    var hash = window.location.hash;
    window.location.hash = '';
    var headerHeight, href, offsetTop;

    headerHeight = $('.header').outerHeight();
    href = $(this).data('anchor');
    offsetTop = $('#' + block).offset().top - headerHeight + 1;

    $('html, body').stop().animate({scrollTop: offsetTop}, 300);
  }
});

function findGetParameter(parameterName) {
  var result = null,
    tmp = [];

  location.search
    .substr(1)
    .split("&")
    .forEach(function (item) {
      tmp = item.split("=");
      if (tmp[0] === parameterName) result = decodeURIComponent(tmp[1]);
    });

  return result;
}



// WEBPACK FOOTER //
// ./src/static/scripts/script.js